import React, { Component } from 'react';
import classNames from 'classnames';
import './Timeline.scss';
import { ICONS } from '../../common/constants';
import IcoMoon from '../IcoMoon';
import Loader from '../Loader';
import { convertLocalTime } from '../../helpers/validationHelper';
import Icon from '../Icon';

class Timeline extends Component {
  
//Modified By: Anjali
//Modified On: 17-11-2023
//Jira-Id: https://bosframework.atlassian.net/browse/JUN-3674
//Reason: text formatting in description for declining a service request

  decodeUnicodeEscapeSequences(input) {
    // First, replace Unicode escape sequences
    const replacedUnicode = input.replace(/(\\)?\\u(\w{4})/g, (match, escaped, p1) => {
      if (escaped) {
        // If there's an extra backslash, treat it as a literal character
        return match;
      }
      return String.fromCharCode(parseInt(p1, 16));
    });
    // Then, replace literal '\n' with newline characters
  const replacedNewlines = replacedUnicode.replace(/\\n/g, '\n');

  return replacedNewlines;
  }

  render() {
    const { activity,loading } = this.props;
    return (
      <div className="timeline">
        <div className="timeline__title">Activity</div>
        {loading === false ? 
        <ul className="timeline__items">
          {activity.map((event, x) => (
            <li
              key={x}
              className={
                classNames(
                  'timeline__item',
                  `timeline__item--${x === 0 ? 'present' : 'past'}`
                )
              }
            >
              <div className="timeline__bar" />
              <div className="timeline__details"><span className="timeline__type">{event.statusName}</span> {event.timestamp ? convertLocalTime(event.timestamp) : null}</div>
              <div className="timeline__log">{event.actor.firstname} {event.actor.lastname}</div>
              <div className="timeline__log">{event.action}</div>
              {
                event.statusName === "Declined" ?
                  <>
                    <div className="timeline__log">Reason Type: {event.reasonType}</div>
                    <div className="timeline__log">Reason Description : {this.decodeUnicodeEscapeSequences(event.reason)}</div>
                  </>
                  :
                  null
              }
              {/* 
                // Modified by: Tarkeshwar Prasad Yadav
                // Modified on: 29/08/2022
                // Jira ticket: JUN-3166
                // Comment: Icon added for Under Review status.
              */}
              <div className="timeline__icon icomoonHourglass">
                {
                  event.statusName==='Under Review'?
                  <Icon
                  glyph="hourglass-end"
                  weight="light"
                  />
                  :
                  event.statusName==='One Year Warranty'?
                  <Icon
                  glyph="certificate"
                  weight="solid"
                  size="solid"
                  />:
                  <IcoMoon
                  glyph={ICONS[event.statusName]}
                />
                }               
              </div>
            </li>
          ))}
        </ul>
        :
        <div className="timeline__title" style={{fontSize:10,color:'grey'}}>Loading...</div>
        }
      </div>
    );
  }
}

export default Timeline;
